export const documentRoutes = {
  plusConditions: "/legal/plus_conditions", //Условия подписки
  campusOffer: "/legal/campus_offer", //Пользовательское соглашение
  terms: "/legal/terms", // Политика конфиденциальности
};
